<template>
  <div class="section1-container">
    <div class="box">
      <swiper :options="swiperOption">
        <swiper-slide v-for="image in slide" :key="image">
          <img :src="image" :alt="image" />
        </swiper-slide>
        <div
          class="swiper-button-prev swiper-button-white ml-3"
          slot="button-prev"
        ></div>
        <div
          class="swiper-button-next swiper-button-white mr-3"
          slot="button-next"
        ></div>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <div class="separator">
        <img src="@images/border-white.png" />
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
const axios = require("axios");
export default {
  name: "section1",
  components: {
    swiper,
    swiperSlide
  },
  created() {
    axios
      .get("/admin/slide.php")
      .then(response => {
        this.slide = response.data.map(data => data.replace(/^/, "/slide/"));
      })
      .catch(error => {
        this.slide = require
          .context("@public/slide", true, /^.*\.jpg|gif|png$/)
          .keys();
        this.slide = this.slide.map(data => {
          return data.replace("./", "/slide/");
        });
      });
  },
  data() {
    return {
      slide: [],
      swiperOption: {
        dragable: false,
        autoplay: {
          delay: 5000
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
      // swiperSlides: [1, 2, 3, 4, 5]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@scss/home/section1.scss";
</style>